<template lang="pug">
  header.admin_global_header(v-if="userName" :class="{ 'is_hamburger_opend': isHamburgerOpend }")
    .admin_global_header_left
      button.admin_global_header_menuButton(
        :aria-expanded="isHamburgerOpend ? 'true' : 'false'"
        :aria-label="isHamburgerOpend ? 'メニューを閉じる' : 'メニューを開く'"
        aria-controls="js_admin_global_navigation"
        name="menu"
        type="button"
        @click="switchGlobalNavigation()")
        b-icon(v-if="!isHamburgerOpend" icon="bars")
        b-icon(v-else icon="times-square")
      a.admin_global_header_link(:href="publicUrl" target="_blank")
        b-icon(icon="home")
        span.admin_global_header_link_text コルテクネコーポレートサイト
      router-link.admin_global_header_link(to="/post")
        b-icon(icon="pen")
        span.admin_global_header_link_text 新規投稿
    .admin_global_header_right
      .admin_global_header_user
        .admin_global_header_avatar
          img(:src="userPhotoUrl")
        .admin_global_header_name {{ userName }}
      .admin_global_header_buttons
        b-button(@click="callLogout()") ログアウト

</template>

<script>
export default {
  name: 'global_header',
  props: [
    'isHamburgerOpend'
  ],
  data: function(){
    return {
      userName: this.$cookies.get('user_name'),
      userPhotoUrl: this.$cookies.get('user_photo_url'),

      publicUrl: process.env.VUE_APP_PUBLIC_HOST
    }
  },
  methods: {
    switchGlobalNavigation() {
      this.$emit('switchNavigation')
    },
    callLogout() {
      this.$store.dispatch('onClickLogout', true)

      // Post.vue 離脱対策
      if(this.$store.state.canLogout) {
        this.$store.dispatch('logout')
      } else {
        this.$buefy.dialog.confirm({
          title: 'ログアウトしますか？',
          message: '保存・更新をせずにログアウトすると、編集した内容は保存されません。',
          confirmText: 'ログアウトする',
          cancelText: 'キャンセル',
          type: 'is-danger',
          size: 'is-medium',
          hasIcon: true,
          icon: 'exclamation-circle',
          onConfirm: () => {
            this.$store.dispatch('logout')
          },
          onCancel: () => {
            this.$store.dispatch('onClickLogout', false)
          }
        })
      }
    }
  }
}
</script>